<template>
  <div>
    <div id="club-header">
      <div class="club-header-main">
        <div class="logo">
          <a href="/AiGuanHuai/agh/careHome">
            <img
              src="http://club.test.neigou.com/Public/Qiye/asset/images/logo.png"
              alt="内购-club-logo"
            />
          </a>
        </div>
        <div class="club-header-btn btn-align-r">
          <a class="btn btn-s btn-line-default" :href="config.url.logout">退出登录</a>
        </div>
      </div>
    </div>
    <div id="club-main">
      <div v-if="!showLeft" class="club-leftbar">
        <div id="setH">
          <div class="user-info" v-if="userInfo">
            <div class="company-logo">
              <img
                src="//club.test.neigou.com"
                onerror="this.src='//club.test.neigou.com/Public/Home/images/logo_default_new.png'"
                alt
              />
            </div>
            <div class="username">您好，{{userInfo.loginUserInfo.enterpriseInfo.abbName}}</div>
            <div class="permissions">管理员：{{userInfo.loginUserInfo.userName}}</div>
            <a class="btn btn-default nav_contacts" href="/AiGuanHuai/agh/oms">通讯录</a>
          </div>
          <ul class="nav">
            <li>
              <a
                dat-nav_id="1"
                dat-nav_bn="AIGUANHUAI"
                dat-class
                dat-action
                :class="href=='/AiGuanHuai/agh/careHome' || href=='/' || href=='/careHome.html'?'active':''"
                href="/AiGuanHuai/agh/careHome"
              >
                <i class="icon">
                  <img src="http://club.test.neigou.com/Public/Qiye/asset/images/nav-icon/01.png" />
                </i>
                <p>乐关怀</p>
                <i class="bg"></i>
              </a>
            </li>
            <li>
              <a
                dat-nav_id="2"
                dat-nav_bn="JIFEN"
                dat-class
                dat-action
                :class="href=='/AiGuanHuai/agh/memberCare'?'active':''"
                href="/AiGuanHuai/agh/memberCare"
              >
                <i class="icon">
                  <img src="http://club.test.neigou.com/Public/Qiye/asset/images/nav-icon/02.png" />
                </i>
                <p>员工关怀</p>
                <i class="bg"></i>
              </a>
            </li>
            <li>
              <a
                dat-nav_id="3"
                dat-nav_bn="NEIGOU"
                dat-class
                dat-action
                :class="href=='/AiGuanHuai/agh/welfareStore'?'active':''"
                href="/AiGuanHuai/agh/welfareStore"
              >
                <i class="icon">
                  <img src="http://club.test.neigou.com/Public/Qiye/asset/images/nav-icon/03.png" />
                </i>
                <p>福利库</p>
                <i class="bg"></i>
              </a>
            </li>
            <li>
              <a
                dat-nav_id="3"
                dat-nav_bn="NEIGOU"
                dat-class
                dat-action
                :class="href=='/AiGuanHuai/agh/hrAssistant'?'active':''"
                href="/AiGuanHuai/agh/hrAssistant"
              >
                <i class="icon">
                  <img src="http://club.test.neigou.com/Public/Qiye/asset/images/nav-icon/03.png" />
                </i>
                <p>HR小助手</p>
                <i class="bg"></i>
              </a>
            </li>
            <li>
              <a
                dat-nav_id="3"
                dat-nav_bn="NEIGOU"
                dat-class
                dat-action
                :class="href=='/AiGuanHuai/agh/carePlan'?'active':''"
                href="/AiGuanHuai/agh/carePlan"
              >
                <i class="icon">
                  <img src="http://club.test.neigou.com/Public/Qiye/asset/images/nav-icon/03.png" />
                </i>
                <p>关怀记录</p>
                <i class="bg"></i>
              </a>
            </li>
            <!-- <li class="line"></li>
            <li>
              <a
                dat-nav_id="9"
                dat-nav_bn="COMPANY-DATA"
                dat-class
                dat-action
                href="/Qiye/Data/neigou"
              >
                <i class="icon">
                  <img src="http://club.test.neigou.com/Public/Qiye/asset/images/nav-icon/09.png">
                </i>
                <p>企业数据</p>
                <i class="bg"></i>
              </a>
            </li>
            <li>
              <a dat-nav_id="6" dat-nav_bn="COMPANY" dat-class dat-action href="/Index/companyShow">
                <i class="icon">
                  <img src="http://club.test.neigou.com/Public/Qiye/asset/images/nav-icon/06.png">
                </i>
                <p>企业设置</p>
                <i class="bg"></i>
              </a>
            </li>-->
          </ul>
          <div id="left-tel">
            <i class="line"></i>
            <p>客服电话 : 400-051-1302</p>
            <span>（工作日 9:30 - 18:00）</span>
          </div>
        </div>
      </div>
      <div v-if="!showLeft" class="club-content">
        <div class="o-content" id="app">
          <app />
        </div>
      </div>
      <div v-if="showLeft" class="o-content" id="app">
        <app />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Vue from "vue";
import Api from "./api/default";
import config from "../config/config";
const config_pop_keys = require("../../stuff/pop_keys");


export default {
  data() {
    return {
        key_words:config.key_words,
      userInfo: null,
      href: null,
      exportsModule: [],
      config: null
    };
  },
  computed: {
    showLeft() {
      // let moduleName1 = this.href.substring(1, this.href.length - 5);
      let split = this.href.split("/");
      let moduleName1 = split[split.length - 1].split("?")[0]
      let moduleName2 = moduleName1
      if(split.length>1) {
        moduleName2 = split[split.length - 2];
      }
      return (
        this.exportsModule.includes(moduleName1) ||
        this.exportsModule.includes(moduleName2)
      );
    }
  },
  created() {
    let _this = this;
    this.href = window.location.pathname;
    this.exportsModule = config_pop_keys;
    Api.getUserinfo(function(cdata) {
      _this.userInfo = cdata;
    });
    console.log(this);
    console.log("nav", config);
    this.config = config;
  }
};
</script>

<style lang="less" scoped>
#club-header .club-header-main .logo {
  float: left;
  padding-top: 10px;

  img {
    height: 42px;
    border-style: none;
    border: 0;
    border: none;
  }
}
</style>